const map = L.map("map", {
	attributionControl: false,
	fullscreenControl: true,
}).setView([51.509865, -0.18092], 13);

window.getBaseLayer(L)
	.addTo(map)
	.on("load", function () {
		document
			.querySelector(".leaflet-control-fullscreen-button")
			.setAttribute("title", `${langText["text_circle_map_view"]}`);
	});

let originMarker = null;
let destinationMarker = null;
let routeLine = null;
let tempRouteLine = null;
let straightLine = null;
let originPoint = null;
let destinationPoint = null;
let originName = "Origin not selected";
let destinationName = "Destination not selected";
let isLoading = false;
let routeRequest = null;
let currentSearchRequest = null;

const elements = {
	originInput: document.getElementById("origin-input"),
	destinationInput: document.getElementById("destination-input"),
	originSuggestions: document.getElementById("origin-suggestions"),
	destinationSuggestions: document.getElementById("destination-suggestions"),
	drawRouteBtn: document.getElementById("draw-route"),
	routeContainer: document.getElementById("route-container"),
	originNameElement: document.getElementById("origin-name"),
	destinationNameElement: document.getElementById("destination-name"),
	distanceKmElement: document.getElementById("distance-km"),
	distanceMilesElement: document.getElementById("distance-miles"),
	durationElement: document.getElementById("duration"),
	instructionsList: document.getElementById("instructions-list"),
	clearOriginBtn: document.getElementById("clear-origin"),
	clearDestinationBtn: document.getElementById("clear-destination"),
	clearAllBtn: document.getElementById("clear-all-btn"),
	swapBtn: document.getElementById("swap-btn"),

	originCoordsLat: document.getElementById("origin-coords-lat"),
	originCoordsLng: document.getElementById("origin-coords-lng"),
	destinationCoordsLat: document.getElementById("destination-coords-lat"),
	destinationCoordsLng: document.getElementById("destination-coords-lng"),

	loadingOverlay: document.getElementById("loading-overlay"),
	loadingMessage: document.getElementById("loading-message"),
	originSearchLoading: document.getElementById("origin-search-loading"),
	destinationSearchLoading: document.getElementById(
		"destination-search-loading",
	),
	originCoordsInput: document.getElementById("origin-coords"),
	destinationCoordsInput: document.getElementById("destination-coords"),
	optimalDistanceElement: document.getElementById("optimal-distance"),
	straightDistanceElement: document.getElementById("straight-distance"),
	optimalDurationElement: document.getElementById("optimal-duration"),
};

function isValidCoordinates(lat, lng) {
	const latNum = parseFloat(lat);
	const lngNum = parseFloat(lng);
	return (
		!isNaN(latNum) &&
		!isNaN(lngNum) &&
		latNum >= -90 &&
		latNum <= 90 &&
		lngNum >= -180 &&
		lngNum <= 180
	);
}

async function setAddressFromCoords(lat, lng, type) {
	const point = L.latLng(parseFloat(lat), parseFloat(lng));

	if (type === "origin") {
		originPoint = point;
		await fetchLocationName(point, "origin");
	} else {
		destinationPoint = point;
		await fetchLocationName(point, "destination");
	}

	return point;
}
function showCustomAlert(message) {
	const alertDiv = document.createElement("div");
	alertDiv.className = "custom-alert";
	alertDiv.innerHTML = `
        ${message}
        <svg class="custom-alert-close" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="20" height="20" aria-label="Close alert"><path d="M18 6L6 18M6 6l12 12"/></svg>
    `;

	document.body.appendChild(alertDiv);

	alertDiv.querySelector(".custom-alert-close").addEventListener("click", function () {
		alertDiv.remove();
	});

	setTimeout(() => {
		if (alertDiv.parentNode) {
			alertDiv.remove();
		}
	}, 3000);
}

function showLoading(message) {
	elements.loadingMessage.textContent = message;
	elements.loadingOverlay.classList.remove("hidden");
}

function hideLoading() {
	elements.loadingOverlay.classList.add("hidden");
}

function showSearchLoading(inputType) {
	if (inputType === "origin") {
		elements.originSearchLoading.classList.remove("hidden");
	} else {
		elements.destinationSearchLoading.classList.remove("hidden");
	}
}

function hideSearchLoading(inputType) {
	if (inputType === "origin") {
		elements.originSearchLoading.classList.add("hidden");
	} else {
		elements.destinationSearchLoading.classList.add("hidden");
	}
}

function debounce(func, wait, immediate) {
	let timeout;
	return function () {
		const context = this;
		const args = arguments;
		const later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		const callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}

function searchLocation(query, suggestionsContainer, type) {
	if (query.length < 3) {
		suggestionsContainer.style.display = "none";
		hideSearchLoading(type);
		return;
	}

	if (currentSearchRequest) {
		currentSearchRequest.cancel(langText["distance_tool_new_request"]);
	}

	const CancelToken = axios.CancelToken;
	currentSearchRequest = CancelToken.source();

	showSearchLoading(type);

	const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
		query,
	)}&addressdetails=1&limit=5&accept-language=en`;

	axios
		.get(url, {
			cancelToken: currentSearchRequest.token,
		})
		.then((response) => {
			const results = response.data;
			suggestionsContainer.innerHTML = "";

			if (results.length === 0) {
				const item = document.createElement("div");
				item.className = "suggestion-item text-gray-500";
				item.textContent = langText["distance_tool_no_results"];
				suggestionsContainer.appendChild(item);
			} else {
				results.forEach((result) => {
					const item = document.createElement("div");
					item.className = "suggestion-item";

					let displayName = result.display_name;
					if (displayName.length > 60) {
						displayName = displayName.substring(0, 60) + "...";
					}

					item.textContent = displayName;
					item.addEventListener("click", function () {
						const inputElement =
							type === "origin"
								? elements.originInput
								: elements.destinationInput;
						inputElement.value = displayName;
						suggestionsContainer.style.display = "none";

						const point = L.latLng(
							parseFloat(result.lat),
							parseFloat(result.lon),
						);

						if (type === "origin") {
							originPoint = point;
							originName = displayName;
						} else {
							destinationPoint = point;
							destinationName = displayName;
						}

						updateRouteInfo();

						// Defer marker, popup, view-change and route draw to the next
						// frame: they force layout and would otherwise delay the
						// list-dismiss / input-fill paint (the ~260ms suggestion INP).
						requestAnimationFrame(function () {
							if (type === "origin") {
								placeOriginMarker(point);
							} else {
								placeDestinationMarker(point);
							}

							map.setView(point, 15);

							if (originPoint && destinationPoint) {
								drawRoute();
							}
						});
					});

					suggestionsContainer.appendChild(item);
				});
			}

			suggestionsContainer.style.display = "block";
			hideSearchLoading(type);
		})
		.catch((error) => {
			if (!axios.isCancel(error)) {
				console.error("Error fetching suggestions:", error);
			}
			hideSearchLoading(type);
		});
}

function placeOriginMarker(point) {
	if (originMarker) map.removeLayer(originMarker);

	originMarker = L.marker(point, {
		icon: L.divIcon({
			className: "origin-marker",
			html: `
                <div class="relative">
                    <div class="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></div>
                    <div class="relative inline-flex rounded-full h-8 w-8 bg-blue-500 border-3 border-blue-200 items-center justify-center">
                       <svg class="w-4 h-4 text-white" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"/>
        </svg>
                    </div>
                </div>
            `,
			iconSize: [32, 32],
			iconAnchor: [16, 16],
		}),
	}).addTo(map);

	originMarker
		.bindPopup(
			`<div class="font-bold text-blue-600">${langText["text_distance_calculator_origin"]}</div>
        `,
		)
		.openPopup();
}

function placeDestinationMarker(point) {
	if (destinationMarker) map.removeLayer(destinationMarker);

	destinationMarker = L.marker(point, {
		icon: L.divIcon({
			className: "destination-marker pulse-animation",
			html: `
                <div class="relative">
                    <div class="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></div>
                    <div class="relative inline-flex rounded-full h-8 w-8 bg-red-500 border-3 border-red-200 items-center justify-center">
                       <svg class="w-4 h-4 text-white" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"/>
                        </svg>
                    </div>
                </div>
            `,
			iconSize: [32, 32],
			iconAnchor: [16, 16],
		}),
	}).addTo(map);

	setTimeout(() => {
		if (destinationMarker && destinationMarker._icon) {
			destinationMarker._icon.classList.remove("pulse-animation");
		}
	}, 3000);

	destinationMarker
		.bindPopup(
			`<div class="font-bold text-red-600">${langText["text_distance_calculator_destination"]}</div>
        `,
		)
		.openPopup();
}

function drawTempRoute() {
	if (tempRouteLine) map.removeLayer(tempRouteLine);

	if (originPoint && destinationPoint) {
		tempRouteLine = L.polyline([originPoint, destinationPoint], {
			color: "#3b82f6",
			weight: 5,
			opacity: 0.8,
			dashArray: "10, 10",
			className: "temp-route",
			lineJoin: "round",
		}).addTo(map);
	}
}

function cancelRouteRequest() {
	if (routeRequest) {
		routeRequest.cancel(langText["distance_tool_cancel_routing"]);
		routeRequest = null;
	}
}

function clearRoute(keepPoints = false) {
	cancelRouteRequest();

	if (originMarker && !keepPoints) map.removeLayer(originMarker);
	if (destinationMarker && !keepPoints) map.removeLayer(destinationMarker);
	if (routeLine) map.removeLayer(routeLine);
	if (tempRouteLine) map.removeLayer(tempRouteLine);
	if (straightLine) map.removeLayer(straightLine);

	document.querySelector("#origin-coords-lat").value = "";
	document.querySelector("#origin-coords-lng").value = "";
	document.querySelector("#destination-coords-lat").value = "";
	document.querySelector("#destination-coords-lng").value = "";

	if (!keepPoints) {
		originPoint = null;
		destinationPoint = null;
		originName = langText["distance_tool_no_origin_selected"];
		destinationName = langText["distance_tool_no_destination_selected"];
		elements.originInput.value = "";
		elements.destinationInput.value = "";
		elements.originCoordsInput.value = "";
		elements.destinationCoordsInput.value = "";

		map.off("click");
		map.on("click", handleMapClick);
	}

	routeLine = null;
	tempRouteLine = null;
	straightLine = null;

	if (!keepPoints) {
		hideRouteContainer();
	}
	elements.instructionsList.innerHTML = "";

	updateRouteInfo();

	isLoading = false;
	const originalText = '<svg class="mr-2" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="display:inline-block;vertical-align:middle"><path d="M3.98262 16.5417C3.47181 16.5417 2.97247 16.6932 2.54774 16.9769 2.12301 17.2607 1.79198 17.6641 1.5965 18.136 1.40102 18.608 1.34987 19.1273 1.44953 19.6283 1.54918 20.1293 1.79516 20.5895 2.15636 20.9507 2.51756 21.3119 2.97776 21.5578 3.47876 21.6575 3.97976 21.7571 4.49906 21.706 4.97099 21.5105 5.44292 21.315 5.84628 20.984 6.13007 20.5593 6.41387 20.1346 6.56534 19.6352 6.56534 19.1244 6.5646 18.4396 6.29225 17.7832 5.80806 17.299 5.32387 16.8148 4.66737 16.5424 3.98262 16.5417z" fill="white"/><path d="M18.5214 14.7604C18.4161 14.7604 18.3119 14.7811 18.2146 14.8214 18.1174 14.8617 18.029 14.9207 17.9546 14.9951 17.8802 15.0696 17.8212 15.1579 17.7809 15.2552 17.7406 15.3524 17.7199 15.4566 17.7199 15.5619V17.271C17.7199 17.643 17.6466 18.0114 17.5042 18.3552 17.3619 18.6989 17.1532 19.0113 16.8901 19.2743 16.627 19.5374 16.3147 19.7461 15.9709 19.8885 15.6272 20.0309 15.2587 20.1042 14.8867 20.1042 14.5146 20.1042 14.1462 20.0309 13.8025 19.8885 13.4587 19.7461 13.1464 19.5374 12.8833 19.2743 12.6202 19.0113 12.4115 18.6989 12.2691 18.3552 12.1267 18.0114 12.0535 17.643 12.0535 17.271V10.0016C12.0535 8.82504 11.5861 7.69669 10.7541 6.86475 9.92221 6.03281 8.79385 5.56543 7.61731 5.56543 6.44077 5.56543 5.31241 6.03281 4.48047 6.86475 3.64853 7.69669 3.18115 8.82504 3.18115 10.0016V13.7806C3.18115 13.9932 3.26559 14.1971 3.4159 14.3474 3.5662 14.4977 3.77006 14.5821 3.98262 14.5821 4.19519 14.5821 4.39904 14.4977 4.54935 14.3474 4.69965 14.1971 4.78409 13.9932 4.78409 13.7806V10.0016C4.78409 9.62952 4.85737 9.2611 4.99976 8.91736 5.14214 8.57362 5.35083 8.26129 5.61392 7.9982 5.87701 7.73511 6.18934 7.52642 6.53308 7.38403 6.87683 7.24165 7.24525 7.16837 7.61731 7.16837 7.98937 7.16837 8.35779 7.24165 8.70154 7.38403 9.04528 7.52642 9.35761 7.73511 9.6207 7.9982 9.88379 8.26129 10.0925 8.57362 10.2349 8.91736 10.3772 9.2611 10.4505 9.62952 10.4505 10.0016V17.271C10.4505 18.4475 10.9179 19.5759 11.7498 20.4078 12.5818 21.2397 13.7101 21.7071 14.8867 21.7071 16.0632 21.7071 17.1916 21.2397 18.0235 20.4078 18.8555 19.5759 19.3228 18.4475 19.3228 17.271V15.5619C19.3229 15.4566 19.3021 15.3524 19.2619 15.2552 19.2216 15.1579 19.1625 15.0696 19.0881 14.9951 19.0137 14.9207 18.9253 14.8617 18.8281 14.8214 18.7309 14.7811 18.6266 14.7604 18.5214 14.7604z" fill="white"/></svg>' + (langText["text_distance_calculator_draw_route"] || 'Draw route');
	elements.drawRouteBtn.innerHTML = originalText;
	elements.drawRouteBtn.disabled = false;

	hideLoading();
}

function clearOrigin() {
	if (originMarker) map.removeLayer(originMarker);
	originPoint = null;
	originName = langText["distance_tool_no_origin_selected"];
	elements.originInput.value = "";
	elements.originSuggestions.style.display = "none";
	updateRouteInfo();

	map.off("click");
	map.on("click", handleMapClick);

	if (!destinationPoint) {
		hideRouteContainer();
	}
}

function clearDestination() {
	if (destinationMarker) map.removeLayer(destinationMarker);
	destinationPoint = null;
	destinationName = langText["distance_tool_no_destination_selected"];
	elements.destinationInput.value = "";
	elements.destinationSuggestions.style.display = "none";
	updateRouteInfo();

	map.off("click");
	map.on("click", handleMapClick);

	if (!originPoint) {
		hideRouteContainer();
	}
}

function showRouteContainer() {
	elements.routeContainer.classList.remove("hidden");
	elements.routeContainer.scrollIntoView({
		behavior: "smooth",
	});
}

function hideRouteContainer() {
	elements.routeContainer.classList.add("hidden");
}

function updateRouteInfo() {
	// elements.originNameElement.textContent = "Origin";
	// elements.destinationNameElement.textContent = "Distination";

	if (originPoint && destinationPoint) {
		const distanceKm = originPoint.distanceTo(destinationPoint) / 1000;
		const distanceMiles = (distanceKm * 0.621371).toFixed(1);
		const durationMinutes = Math.round(distanceKm * 1.5);

		elements.distanceKmElement.textContent = distanceKm.toFixed(1);
		elements.distanceMilesElement.textContent = distanceMiles;
		elements.durationElement.textContent = durationMinutes;
	} else {
		elements.distanceKmElement.textContent = "0";
		elements.distanceMilesElement.textContent = "0";
		elements.durationElement.textContent = "0";
	}
}

async function fetchLocationName(point, type) {
	try {
		const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${point.lat}&lon=${point.lng}&accept-language=en`;
		const response = await axios.get(url);

		const address = response.data.address;
		let displayName = "";

		if (address.road) displayName += address.road + "، ";
		if (address.neighbourhood) displayName += address.neighbourhood + "، ";
		if (address.suburb) displayName += address.suburb + "، ";
		if (address.city) displayName += address.city + "، ";
		if (address.state) displayName += address.state;

		if (displayName.endsWith("، ")) {
			displayName = displayName.slice(0, -2);
		}

		if (displayName) {
			if (type === "origin") {
				elements.originInput.value = displayName;
				originName = displayName;
				placeOriginMarker(point);
			} else {
				elements.destinationInput.value = displayName;
				destinationName = displayName;
				placeDestinationMarker(point);
			}
		} else {
			const fallbackName = `${point.lat.toFixed(4)}, ${point.lng.toFixed(4)}`;
			if (type === "origin") {
				elements.originInput.value = fallbackName;
				originName = fallbackName;
				placeOriginMarker(point);
			} else {
				elements.destinationInput.value = fallbackName;
				destinationName = fallbackName;
				placeDestinationMarker(point);
			}
		}

		updateRouteInfo();
	} catch (error) {
		console.error("Error fetching location name:", error);
		const fallbackName = `${point.lat.toFixed(4)}, ${point.lng.toFixed(4)}`;
		if (type === "origin") {
			elements.originInput.value = fallbackName;
			originName = fallbackName;
			placeOriginMarker(point);
		} else {
			elements.destinationInput.value = fallbackName;
			destinationName = fallbackName;
			placeDestinationMarker(point);
		}
		updateRouteInfo();
	} finally {
		hideLoading();
	}
}

async function drawRoute() {
	if (
		(!elements.originInput.value &&
			(elements.originCoordsLat.value || elements.originCoordsLng.value)) ||
		(!elements.destinationInput.value &&
			(elements.destinationCoordsLat.value ||
				elements.destinationCoordsLng.value))
	) {
		try {
			showLoading(langText["distance_tool_processing"]);

			if (
				!elements.originInput.value &&
				(elements.originCoordsLat.value || elements.originCoordsLng.value)
			) {
				if (
					!elements.originCoordsLat.value ||
					!elements.originCoordsLng.value
				) {
					throw new Error(
						"Please enter both latitude and longitude for origin",
					);
				}

				if (
					!isValidCoordinates(
						elements.originCoordsLat.value,
						elements.originCoordsLng.value,
					)
				) {
					throw new Error(
						"Invalid origin coordinates. Please enter valid latitude and longitude.",
					);
				}

				await setAddressFromCoords(
					elements.originCoordsLat.value,
					elements.originCoordsLng.value,
					"origin",
				);
			}

			if (
				!elements.destinationInput.value &&
				(elements.destinationCoordsLat.value ||
					elements.destinationCoordsLng.value)
			) {
				if (
					!elements.destinationCoordsLat.value ||
					!elements.destinationCoordsLng.value
				) {
					throw new Error(
						"Please enter both latitude and longitude for destination",
					);
				}

				if (
					!isValidCoordinates(
						elements.destinationCoordsLat.value,
						elements.destinationCoordsLng.value,
					)
				) {
					throw new Error(
						"Invalid destination coordinates. Please enter valid latitude and longitude.",
					);
				}

				await setAddressFromCoords(
					elements.destinationCoordsLat.value,
					elements.destinationCoordsLng.value,
					"destination",
				);
			}
		} catch (error) {
			hideLoading();
			showCustomAlert(error.message);
			return;
		} finally {
			hideLoading();
		}
	}

	if (!originPoint || !destinationPoint) {
		showCustomAlert(langText["distance_tool_either"]);
		return;
	}

	if (isLoading) {
		cancelRouteRequest();
		clearRoute(true);
	}

	isLoading = true;
	const originalText = elements.drawRouteBtn.innerHTML;
	elements.drawRouteBtn.innerHTML = `<span>${langText["distance_tool_drawing_route"]}</span><div class="loading-spinner"></div>`;
	elements.drawRouteBtn.disabled = true;

	showLoading(langText["distance_tool_calculating"]);

	if (routeLine) map.removeLayer(routeLine);
	if (straightLine) map.removeLayer(straightLine);
	if (tempRouteLine) map.removeLayer(tempRouteLine);

	straightLine = L.polyline([originPoint, destinationPoint], {
		color: "#ef4444",
		weight: 3,
		dashArray: "5, 5",
		opacity: 0.7,
		className: "straight-route-line",
	}).addTo(map);

	const straightDistance = originPoint.distanceTo(destinationPoint) / 1000;
	const straightDistanceMiles = (straightDistance * 0.621371).toFixed(1);

	showRouteContainer();
	elements.instructionsList.innerHTML = "";

	const osrmUrl = `https://router.project-osrm.org/route/v1/driving/${originPoint.lng},${originPoint.lat};${destinationPoint.lng},${destinationPoint.lat}?overview=full&geometries=geojson&steps=true&alternatives=false`;

	const CancelToken = axios.CancelToken;
	const source = CancelToken.source();
	routeRequest = source;

	try {
		const response = await axios.get(osrmUrl, {
			cancelToken: source.token,
		});

		const route = response.data.routes[0];
		const distanceKm = (route.distance / 1000).toFixed(1);
		const durationMinutes = Math.round(route.duration / 60);

		const routeCoordinates = route.geometry.coordinates.map((coord) => [
			coord[1],
			coord[0],
		]);

		routeLine = L.polyline(routeCoordinates, {
			color: "#3b82f6",
			weight: 5,
			opacity: 0.8,
			lineJoin: "round",
			className: "optimal-route-line",
		}).addTo(map);

		updateRouteComparison(distanceKm, straightDistance, durationMinutes);

		const bounds = L.latLngBounds([
			...routeCoordinates,
			originPoint,
			destinationPoint,
		]);
		map.fitBounds(bounds, {
			padding: [50, 50],
		});

		displayRouteInstructions(route.legs[0].steps);

		if (!elements.originCoordsLat.value || !elements.originCoordsLng.value) {
			elements.originCoordsLat.value = originPoint.lat.toFixed(6);
			elements.originCoordsLng.value = originPoint.lng.toFixed(6);
		}

		if (
			!elements.destinationCoordsLat.value ||
			!elements.destinationCoordsLng.value
		) {
			elements.destinationCoordsLat.value = destinationPoint.lat.toFixed(6);
			elements.destinationCoordsLng.value = destinationPoint.lng.toFixed(6);
		}
	} catch (error) {
		if (axios.isCancel(error)) {
			console.log("Route request canceled:", error.message);
			return;
		}

		console.error("Error fetching route:", error);

		updateRouteComparison(
			straightDistance.toFixed(1),
			straightDistance,
			Math.round(straightDistance * 1.5),
		);

		showCustomAlert(langText["distance_tool_route_error"]);
	} finally {
		isLoading = false;
		routeRequest = null;
		elements.drawRouteBtn.innerHTML = originalText;
		elements.drawRouteBtn.disabled = false;
		hideLoading();

		elements.originSuggestions.style.display = "none";
		elements.destinationSuggestions.style.display = "none";
	}
}

function updateRouteComparison(optimalDistance, straightDistance, duration) {
	const optimalDistanceEl = document.getElementById("optimal-distance");
	const straightDistanceEl = document.getElementById("straight-distance");
	const optimalDurationEl = document.getElementById("optimal-duration");

	if (optimalDistanceEl)
		optimalDistanceEl.textContent = `${optimalDistance} km (${(
			optimalDistance * 0.621371
		).toFixed(1)} mi)`;

	if (straightDistanceEl)
		straightDistanceEl.textContent = `${straightDistance.toFixed(1)} km (${(
			straightDistance * 0.621371
		).toFixed(1)} mi)`;
	// if (optimalDurationEl) optimalDurationEl.textContent = `${duration} min`;

	if (elements.distanceKmElement)
		elements.distanceKmElement.textContent = optimalDistance;
	if (elements.distanceMilesElement) {
		elements.distanceMilesElement.textContent = (
			straightDistance * 0.621371
		).toFixed(1);
	}
	if (elements.durationElement) elements.durationElement.textContent = duration;
}

function displayRouteInstructions(steps) {
	elements.instructionsList.innerHTML = "";

	const header = document.createElement("div");
	header.className = "instructions-header";
	header.innerHTML = `
        <div style="color: black;" class="font-medium">${langText["text_distance_calculator_route_guide"]}</div>
        <svg class="w-4 h-4 transition-transform duration-200" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    `;

	const content = document.createElement("div");
	content.className = "instructions-content expanded";

	let isExpanded = true;

	// Initial state: content is expanded (isExpanded=true), so rotate the
	// chevron to point up (^) — the visual cue for "click to collapse".
	const initialChevron = header.querySelector("svg");
	if (initialChevron) initialChevron.style.transform = "rotate(180deg)";

	header.addEventListener("click", function () {
		isExpanded = !isExpanded;
		const chevron = header.querySelector("svg");
		if (isExpanded) {
			content.classList.remove("collapsed");
			content.classList.add("expanded");
			if (chevron) chevron.style.transform = "rotate(180deg)";
		} else {
			content.classList.remove("expanded");
			content.classList.add("collapsed");
			if (chevron) chevron.style.transform = "";
		}
	});

	if (steps.length > 0) {
		const destinationItem = document.createElement("div");
		destinationItem.className =
			"flex items-start py-3 px-4 hover:bg-gray-50 hover:bg-opacity-10 transition-colors";

		const destinationIcon = document.createElement("div");
		destinationIcon.className =
			"flex items-center justify-center w-6 h-6 rounded-full bg-red-500 text-white ml-3 mr-3 mt-1 flex-shrink-0";
		destinationIcon.innerHTML = `
            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"></path>
            </svg>
        `;

		const destinationContent = document.createElement("div");
		destinationContent.className = "flex-1";

		const destinationText = document.createElement("div");
		destinationText.className = "text-black font-bold";
		destinationText.textContent = document.querySelector("#origin-input").value;

		destinationContent.appendChild(destinationText);
		destinationItem.appendChild(destinationIcon);
		destinationItem.appendChild(destinationContent);

		content.appendChild(destinationItem);
	}

	steps.forEach((step, index) => {
		if (
			step.maneuver &&
			(step.maneuver.type !== "turn" ||
				(step.maneuver.modifier !== "straight" &&
					step.maneuver.modifier !== "slight right" &&
					step.maneuver.modifier !== "slight left"))
		) {
			const instructionItem = document.createElement("div");
			instructionItem.className =
				"flex items-start py-3 px-4 hover:bg-gray-50 transition-colors";

			const instructionNumber = document.createElement("div");
			instructionNumber.className =
				"flex items-center justify-center w-6 h-6 rounded-full bg-blue-500 text-white text-sm font-medium ml-3 mr-3 mt-1 flex-shrink-0";
			instructionNumber.textContent = index + 1;

			const instructionContent = document.createElement("div");
			instructionContent.className = "flex-1";

			const instructionMainText = document.createElement("div");
			instructionMainText.className = "text-gray-800 font-medium";
			instructionMainText.textContent =
				step.name || step.maneuver.instruction || "Continue route";

			const instructionDistance = document.createElement("div");
			instructionDistance.className = "text-gray-500 text-sm mt-1";
			instructionDistance.textContent = `${(step.distance / 1000).toFixed(
				1,
			)} km`;

			instructionContent.appendChild(instructionMainText);
			instructionContent.appendChild(instructionDistance);

			instructionItem.appendChild(instructionNumber);
			instructionItem.appendChild(instructionContent);

			content.appendChild(instructionItem);
		}
	});

	const destinationValue = document.querySelector("#destination-input").value;

	const destinationItem = document.createElement("div");
	destinationItem.className =
		"flex items-start py-3 px-4 hover:bg-white hover:bg-opacity-5 transition-colors";

	const destinationIcon = document.createElement("div");
	destinationIcon.className =
		"flex items-center justify-center w-6 h-6 rounded-full bg-green-500 text-white ml-3 mr-3 mt-1 flex-shrink-0";
	destinationIcon.innerHTML = `
            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"></path>
            </svg>
        `;

	const destinationContent = document.createElement("div");
	destinationContent.className = "flex-1";

	const destinationText = document.createElement("div");
	destinationText.className = "text-black font-medium";
	destinationText.textContent = destinationValue;

	destinationContent.appendChild(destinationText);
	destinationItem.appendChild(destinationIcon);
	destinationItem.appendChild(destinationContent);

	content.appendChild(destinationItem);

	elements.instructionsList.appendChild(header);
	elements.instructionsList.appendChild(content);
}

function handleMapClick(e) {
	if (originPoint && destinationPoint) {
		showCustomAlert(langText["distance_tool_click_clear_btn"]);
		return;
	}

	if (isLoading) {
		if (confirm(langText["distance_tool_cancel_current_route"])) {
			clearRoute(true);
		} else {
			return;
		}
	}

	const point = e.latlng;
	const coords = `${point.lat.toFixed(6)},${point.lng.toFixed(6)}`;

	if (!originPoint) {
		originPoint = point;
		elements.originCoordsLat.value = point.lat.toFixed(6);
		elements.originCoordsLng.value = point.lng.toFixed(6);
		showLoading(langText["distance_tool_fetch_origin"]);
		fetchLocationName(originPoint, "origin");
		placeOriginMarker(originPoint);
		updateRouteInfo();
	} else if (!destinationPoint) {
		destinationPoint = point;
		elements.destinationCoordsLat.value = point.lat.toFixed(6);
		elements.destinationCoordsLng.value = point.lng.toFixed(6);
		showLoading(langText["distance_tool_fetch_destination"]);
		fetchLocationName(destinationPoint, "destination");
		placeDestinationMarker(destinationPoint);
		updateRouteInfo();
		drawRoute();
	}
}

function clearOriginCoords() {
	elements.originCoordsLat.value = "";
	elements.originCoordsLng.value = "";
	if (!originPoint) return;

	originPoint = null;
	originName = langText["distance_tool_no_origin_selected"];
	elements.originInput.value = "";
	if (originMarker) map.removeLayer(originMarker);
	updateRouteInfo();
}

function clearDestinationCoords() {
	elements.destinationCoordsLat.value = "";
	elements.destinationCoordsLng.value = "";
	if (!destinationPoint) return;

	destinationPoint = null;
	destinationName = langText["distance_tool_no_destination_selected"];
	elements.destinationInput.value = "";
	if (destinationMarker) map.removeLayer(destinationMarker);
	updateRouteInfo();
}

function setupEventListeners() {
	map.on("click", handleMapClick);

	elements.originInput.addEventListener("focus", function () {
		if (this.value.length >= 3) {
			searchLocation(this.value, elements.originSuggestions, "origin");
		}
	});

	elements.destinationInput.addEventListener("focus", function () {
		if (this.value.length >= 3) {
			searchLocation(
				this.value,
				elements.destinationSuggestions,
				"destination",
			);
		}
	});

	elements.originInput.addEventListener(
		"input",
		debounce(function () {
			searchLocation(this.value, elements.originSuggestions, "origin");
		}, 300),
	);

	elements.destinationInput.addEventListener(
		"input",
		debounce(function () {
			searchLocation(
				this.value,
				elements.destinationSuggestions,
				"destination",
			);
		}, 300),
	);

	document.addEventListener("click", function (e) {
		if (
			!elements.originInput.contains(e.target) &&
			!elements.originSuggestions.contains(e.target)
		) {
			elements.originSuggestions.style.display = "none";
		}

		if (
			!elements.destinationInput.contains(e.target) &&
			!elements.destinationSuggestions.contains(e.target)
		) {
			elements.destinationSuggestions.style.display = "none";
		}
	});

	elements.drawRouteBtn.addEventListener("click", function () {
		if (originPoint && destinationPoint) {
			drawRoute();
		} else {
			showCustomAlert(langText["distance_tool_either"]);
		}
	});

	elements.clearOriginBtn.addEventListener("click", function (e) {
		e.stopPropagation();
		if (isLoading) {
			if (confirm(langText["distance_tool_cancel_current_route"])) {
				clearOrigin();
			}
		} else {
			clearOrigin();
		}
	});

	elements.clearDestinationBtn.addEventListener("click", function (e) {
		e.stopPropagation();
		if (isLoading) {
			if (confirm(langText["cancel_distance"])) {
				clearDestination();
			}
		} else {
			clearDestination();
		}
	});

	elements.originCoordsLat.addEventListener("change", function () {
		if (
			this.value &&
			elements.originCoordsLng.value &&
			isValidCoordinates(this.value, elements.originCoordsLng.value)
		) {
			setAddressFromCoords(
				this.value,
				elements.originCoordsLng.value,
				"origin",
			);
		}
	});

	elements.originCoordsLng.addEventListener("change", function () {
		if (
			this.value &&
			elements.originCoordsLat.value &&
			isValidCoordinates(elements.originCoordsLat.value, this.value)
		) {
			setAddressFromCoords(
				elements.originCoordsLat.value,
				this.value,
				"origin",
			);
		}
	});

	// elements.destinationCoordsInput.addEventListener("change", function () {
	//     if (this.value && isValidCoordinates(this.value)) {
	//         setAddressFromCoords(this.value, "destination");
	//     }
	// });

	elements.destinationCoordsLat.addEventListener("change", function () {
		if (
			this.value &&
			elements.destinationCoordsLng.value &&
			isValidCoordinates(this.value, elements.destinationCoordsLng.value)
		) {
			setAddressFromCoords(
				this.value,
				elements.destinationCoordsLng.value,
				"destination",
			);
		}
	});

	elements.destinationCoordsLng.addEventListener("change", function () {
		if (
			this.value &&
			elements.destinationCoordsLat.value &&
			isValidCoordinates(elements.destinationCoordsLat.value, this.value)
		) {
			setAddressFromCoords(
				elements.destinationCoordsLat.value,
				this.value,
				"destination",
			);
		}
	});

	elements.clearAllBtn.addEventListener("click", function () {
		if (isLoading) {
			if (confirm(langText["cancel_all"])) {
				clearRoute();
			}
		} else {
			clearRoute();
		}
	});

	elements.swapBtn.addEventListener("click", function () {
		if (originPoint && destinationPoint) {
			const tempPoint = originPoint;
			const tempName = originName;

			originPoint = destinationPoint;
			originName = destinationName;

			destinationPoint = tempPoint;
			destinationName = tempName;

			const tempInput = elements.originInput.value;
			elements.originInput.value = elements.destinationInput.value;
			elements.destinationInput.value = tempInput;

			placeOriginMarker(originPoint);
			placeDestinationMarker(destinationPoint);

			drawRoute();
		} else if (originPoint && !destinationPoint) {
			destinationPoint = originPoint;
			destinationName = originName;
			elements.destinationInput.value = elements.originInput.value;

			originPoint = null;
			originName = langText["distance_tool_no_origin_selected"];

			elements.originInput.value = "";

			if (originMarker) map.removeLayer(originMarker);
			placeDestinationMarker(destinationPoint);
			updateRouteInfo();
		} else if (!originPoint && destinationPoint) {
			originPoint = destinationPoint;
			originName = destinationName;
			elements.originInput.value = elements.destinationInput.value;

			destinationPoint = null;
			destinationName = langText["distance_tool_no_destination_selected"];

			elements.destinationInput.value = "";

			if (destinationMarker) map.removeLayer(destinationMarker);
			placeOriginMarker(originPoint);
			updateRouteInfo();
		}
	});

	elements.drawRouteBtn.addEventListener("mouseenter", function () {
		// this.querySelector("i").classList.add("fa-beat");
	});

	elements.drawRouteBtn.addEventListener("mouseleave", function () {
		// this.querySelector("i").classList.remove("fa-beat");
	});

	const container = document.querySelector(".route-path-container");
	container.className = "route-path-container";
	container.classList.add("show-both");
}

document.addEventListener("DOMContentLoaded", function () {
	setupEventListeners();

	document.querySelector(".language").addEventListener("click", function () {
		document.querySelector(".lang").classList.toggle("active");
	});
});
